/**
  * @class meleModalWindow
  * @description
  *
  * # Purpose
  * Implements `<mele-modalwindow>` custom web element.
  *
  * # Use
  * Create element in HTML:
  * ```
  * parentEl.innerHTML += '<mele-modalwindow></mele-modalwindow>';
  * ```
  * Create element in JavaScript:
  * ```
  * parentEl.appendChildren({
  *   tag: 'mele-modalwindow',
  *   ... other attributes ...
  * })
  * ```
  *
  * # Implementation notes
  *
  */

import meleWindow from 'meleWindow'

const PROPERTIES = _.extend({}, {
  outclick: { type: 'string', description: "what to do when user clicks on dimmed area outside the modal; if set to ':modal.cancel', will close the modal window, otherwise if set, will invoke .publish('mmButtonClicked',{key:this.outclick}) " },
  close: { type: 'boolean', description: 'whether to show close button' },
}, meleWindow._properties)

export default class meleModalWindow extends meleWindow {
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /**
  * Creates internal DOM structure.
  */
  init() {
    super.init()

    // insert system close button
    this.prependChildren({
      tag: 'mele-button',
      key: 'close',
      type: 'toolbar',
      iconleft: 'sys.close',
      eventButtonClicked: ()=>{ this.modalClose() },
    })
  } // init

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /**
  * Handle click outside modal window
  */
  onclick(event) {
    if(event.target===this && this.outclick) {
      if(this.outclick==':modal.cancel') {
        this.modalClose()
      }else {
        this.publish('mmButtonClicked', { holder: this.key, button: this.outclick })
      }
    }
  }

  formModalclose() {
    this.modalClose()
  }
} // class meleModalWindow

meleModalWindow._properties = PROPERTIES
meleModalWindow.observedAttributes = _.keys(PROPERTIES)

window.customElements.define('mele-modalwindow', meleModalWindow)
